import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useChild } from '../context/ChildContext';
import { UserContext } from '../context/UserContext';
import ChildSidebar from './viewsChild/MySidebarChild';
import ChildDashboardHeader from './viewsChild/ChildDashboardHeader';
import ChildAccountCard from './viewsChild/ChildAccountCard';
import ModalTransactions from './viewsChild/ModalTransactions';
import AccountCardsFrame from './viewsChild/AccountCardsFrame';
import './ChildDashboard.css';

function ChildDashboard() {
    const { user } = React.useContext(UserContext);
    const { dashboardData, loading, error } = useChild();
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [isTransactionModalOpen, setIsTransactionModalOpen] = useState(false);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const location = useLocation();

    if (loading) return <div className="child-dashboard__loading">Loading...</div>;
    if (error) return <div className="child-dashboard__error">{error}</div>;

    const openTransactionModal = (account) => {
        setSelectedAccount(account);
        setIsTransactionModalOpen(true);
    };

    const closeTransactionModal = () => {
        setIsTransactionModalOpen(false);
        setSelectedAccount(null);
    };

    const handleSidebarToggle = (collapsed) => {
        setIsSidebarCollapsed(collapsed);
    };

    const renderDashboardContent = () => (
        <>
            <ChildDashboardHeader
                childId={user.details?.user_id}
                childName={user.details?.display_name}
                avatarUrl={user.details?.avatar_url}
                refreshTrigger={dashboardData?.lastUpdated}
            />
            <div className="child-dashboard__summary">
                
            </div>
            <AccountCardsFrame>
                {dashboardData?.accounts?.map(account => (
                    <ChildAccountCard
                        key={account.accountId}
                        account={{
                            ...account,
                            isDefault: account.isDefault || false,
                            calculatedAllowance: account.calculatedAllowance || 0
                        }}
                        onViewTransactions={() => openTransactionModal(account)}
                    />
                ))}
            </AccountCardsFrame>
            <ModalTransactions
                userId={user.details?.user_id}
                accountId={selectedAccount?.accountId || ''}
                accountName={selectedAccount?.accountName || ''}
                isOpen={isTransactionModalOpen}
                onRequestClose={closeTransactionModal}
            />
        </>
    );

    return (
        <div className="child-dashboard">
            <ChildSidebar onToggle={handleSidebarToggle} isCollapsed={isSidebarCollapsed} />
            <div className={`child-dashboard__content ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
                {location.pathname === '/child/dashboard' ? renderDashboardContent() : <Outlet />}
            </div>
        </div>
    );
}

export default ChildDashboard;